// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--2iXoO","linkContainer":"footer-module--link-container--2o61z","link":"footer-module--link--3ahiR"};